module.exports = __webpack_public_path__ + "img/parents.98edf8e.webp";